var Modernizr = require('modernizr');
var exports = (module.exports = {});
var templateDeliveryAddress = require('pug-loader!../../../../views/settings/delivery-address.pug');

var s;
var SettingsController = {
  settings: {
    sidebarWrapper: $('.settings-sidebar'),
    contentWrapper: $('.settings-content'),
    stickyElement: $('.sidebar-navigation'),
    navbarEl: $('.navbar')
  },

  init: function() {
    s = this.settings;
    this.setSameHeight();
    this.bindUIelement();

    $(window).resize(this.setSameHeight);
  },

  bindUIelement: function() {
    const that = this;

    if (s.stickyElement.length > 0) {
      var elTop = s.stickyElement.offset().top - s.navbarEl.outerHeight();
      var elBottom = elTop + s.stickyElement.parent().outerHeight() - s.stickyElement.outerHeight();

      $(window).scroll(function() {
        s.stickyElement.toggleClass('sticky', $(window).scrollTop() >= elTop);
        s.stickyElement.toggleClass('sticky-bottom', $(window).scrollTop() > elBottom);
      });
    }

    $('#addAddressButtonTrigger').on('click', function(e) {
      e.preventDefault();

      var _form = $('#addNewBillingForm');

      //validate billing form then make the request
      that
        .validateBillingForm(_form)
        .then(() => {
          var req = $.ajax({
            type: _form.attr('method'),
            url: _form.attr('action'),
            data: _form.serialize()
          });

          req.done(function() {
            that.getBillingAddress();
            $('#newBillingAddressModal').modal('toggle');
            _form[0].reset();
          });
        })
        .catch(err => {
          $('#billingError')
            .text(err)
            .fadeIn();

          setTimeout(() => {
            $('#billingError').fadeOut();
          }, 3000);
          //display error message
        });
    });

    //modal "save" button
    $('#editBillingAddress').on('submit', function(e) {
      e.preventDefault();

      var _form = $('form#editBillingAddress');
      //at this moment the fields have values
      that
        .validateBillingForm(_form)
        .then(() => {
          var req = $.ajax({
            type: _form.attr('method'),
            url: _form.attr('action'),
            data: _form.serialize()
          });

          req.done(function() {
            that.getBillingAddress();
            $('#editBillingAddressModal').modal('toggle');
            _form[0].reset();
          });
        })
        .catch(err => {
          $('#billingError')
            .text(err)
            .fadeIn();

          setTimeout(() => {
            $('#billingError').fadeOut();
          }, 3000);
        });
    });

    $('body').on('click', '.btn-edit-billing', function(ev) {
      ev.preventDefault();

      if (!$(ev.currentTarget).attr('data-value')) {
        return;
      }

      var data = {
        billing_id: jQuery(ev.currentTarget).attr('data-value')
      };

      var form = $(ev.currentTarget)
        .closest('.panel-body')
        .find('form');

      var inputs = form.find('input, select');
      var values = {};
      inputs.each(function() {
        values[this.name] = $(this).val();
      });

      values['billing_id'] = data.billing_id;

      data = Object.assign(data, values);

      var _formInputs = $('#editBillingAddressModal').find('input, select');

      _formInputs.each(function(el) {
        var el = $(this);
        el.val(data[el.attr('name')]);
      });

      // that.editBillingAddress(data)
      //     .then(that.getBillingAddress)
      //     .catch(function (err) {
      //         console.log(err);
      //     });

      //validate billing form then make the request
      // that.validateBillingForm(_form)
      //     .then(() => {
      // var req = $.ajax({
      //     type: _form.attr('method'),
      //     url: _form.attr('action'),
      //     data: _form.serialize(),
      // });

      // req.done(function () {
      //     that.getBillingAddress();
      //     $('#newBillingAddressModal').modal('toggle');
      //     _form[0].reset();
      // });

      //     })
      //     .catch((err) => {

      // $("#billingError").text(err).fadeIn();

      // setTimeout(() => {
      //     $("#billingError").fadeOut();
      // }, 3000)
      //         //display error message
      //     });
    });

    $('body').on('click', '.btn-edit-delivery', function(ev) {
      ev.preventDefault();

      if (!$(ev.currentTarget).attr('data-value')) {
        return;
      }

      var data = {
        delivery_id: jQuery(ev.currentTarget).attr('data-value')
      };

      var form = $(ev.currentTarget)
        .closest('.panel-body')
        .find('form');

      var inputs = form.find('input, select');
      var values = {};
      inputs.each(function() {
        values[this.name] = $(this).val();
      });

      values['delivery_id'] = data.delivery_id;

      data = Object.assign(data, values);

      var _formInputs = $('form#editDeliveryAddressForm').find('input, select');

      _formInputs.each(function(el) {
        var el = $(this);
        el.val(data[el.attr('name')]);
      });
    });

    //submit delivery form
    $('form#editDeliveryAddressForm').on('submit', function(e) {
      e.preventDefault();

      var _form = $('form#editDeliveryAddressForm');
      //at this moment the fields have values
      that
        .validateDeliveryForm(_form)
        .then(() => {
          var req = $.ajax({
            type: _form.attr('method'),
            url: _form.attr('action'),
            data: _form.serialize()
          });

          req.done(function() {
            that.getDeliveryAddress();
            $('#editDeliveryAddressModal').modal('toggle');
            _form[0].reset();
          });
        })
        .catch(err => {
          $('#deliveryError')
            .text(err)
            .fadeIn();

          setTimeout(() => {
            $('#deliveryError').fadeOut();
          }, 3000);
        });
    });

    $('#addAddressDeliveryTrigger').on('click', function(e) {
      e.preventDefault();

      var _form = $('#addNewDeliveryForm');

      /**
       * validate delivery form then make the request
       */
      that
        .validateDeliveryForm(_form)
        .then(() => {
          var req = $.ajax({
            type: _form.attr('method'),
            url: _form.attr('action'),
            data: _form.serialize()
          });

          req.done(function() {
            that.getDeliveryAddress();
            $('#newDeliveryAddressModal').modal('toggle');
          });

          return;
        })
        .catch(err => {
          $('#deliveryError')
            .text(err)
            .fadeIn();

          setTimeout(() => {
            $('#deliveryError').fadeOut();
          }, 3000);
          //display error message
        });
    });

    jQuery('body').on('click', '.btn-delete-billing', function(ev) {
      ev.preventDefault();

      var data = {
        billing_id: jQuery(ev.currentTarget).attr('data-value')
      };

      that
        .deleteBillingAddress(data)
        .then(that.getBillingAddress)
        .catch(function(err) {
          console.log(err);
        });
    });

    jQuery('body').on('click', '.btn-delete-delivery', function(ev) {
      ev.preventDefault();

      var data = {
        delivery_id: jQuery(ev.currentTarget).attr('data-value')
      };

      that
        .deleteDeliveryAddress(data)
        .then(that.getDeliveryAddress)
        .catch(function(err) {
          console.log(err);
        });
    });

    return false;
  },

  validateBillingForm: function(form) {
    return new Promise((resolve, reject) => {
      let values = {};
      //get required values
      $.each(form.serializeArray(), function(i, field) {
        values[field.name] = field.value.toString();
      });

      if (
        values['billing_address_name'].length < 2 ||
        values['billing_phone'].length < 2 ||
        values['billing_address_1'].length < 2 ||
        values['billing_city'].length < 2 ||
        values['billing_zipcode'].length < 2 ||
        values['billing_registration_number'].length < 2 ||
        values['billing_vat'].length < 2
      ) {
        reject('Please enter all the required details.');
      }

      if (!values['billing_phone'].match('^[0-9]*$') || !values['billing_phone'].length > 5) {
        reject('Phone number is not valid.');
      }

      // console.log(values);
      resolve(values);
    });
  },

  validateDeliveryForm: function(form) {
    return new Promise((resolve, reject) => {
      let values = {};
      //get required values
      $.each(form.serializeArray(), function(i, field) {
        values[field.name] = field.value.toString();
      });

      if (
        values['delivery_address_name'].length < 2 ||
        values['delivery_name'].length < 2 ||
        values['delivery_phone'].length < 2 ||
        values['delivery_address_1'].length < 2 ||
        values['delivery_city'].length < 2 ||
        values['delivery_zipcode'].length < 2
      ) {
        reject('Please enter all the required details.');
      }

      if (!values['delivery_phone'].match('^[0-9]*$') || !values['delivery_phone'].length > 5) {
        reject('Phone number is not valid.');
      }

      // console.log(values);
      resolve(values);
    });
  },

  setSameHeight: function() {
    s.sidebarWrapper.css('height', 'auto');
    s.contentWrapper.css('height', 'auto');

    if (Modernizr.mq('(min-width: 992px)')) {
      var max = Math.max(s.sidebarWrapper.outerHeight(), s.contentWrapper.outerHeight());
      console.log(max);
      s.sidebarWrapper.css('height', max);
      s.contentWrapper.css('height', max);
    }

    return false;
  },

  getBillingAddress: function() {
    $.ajax({
      type: 'GET',
      url: '/account/billing',
      success: function(data) {
        jQuery('#billing-address-wrapper').html(data);
      }
    }).catch(function(err) {
      console.log(err);
    });
  },

  editBillingAddress: function(data) {
    if (!data.billing_id) {
      return Promise.reject();
    }

    return $.ajax({
      type: 'post',
      url: '/account/billing/' + data.billing_id,
      data: JSON.stringify(data),
      contentType: 'application/json'
    });
  },
  deleteBillingAddress: function(data) {
    return $.ajax({
      type: 'delete',
      url: '/account/billing',
      data: JSON.stringify(data),
      contentType: 'application/json'
    });
  },

  getDeliveryAddress: function() {
    $.ajax({
      type: 'get',
      url: '/account/delivery',
      success: function(data) {
        var locals = data;
        var html = templateDeliveryAddress({
          delivery_addressses: locals
        });
        $('#delivery-address-wrapper').html(html);
      }
    }).catch(function(err) {
      console.log(err);
    });
  },

  deleteDeliveryAddress: function(data) {
    return $.ajax({
      type: 'delete',
      url: '/account/delivery',
      data: JSON.stringify(data),
      contentType: 'application/json'
    });
  }
};

// var SettingsController = function(toggleFormTrigger, newAddressElement, newBillingAddressForm) {

//     //constructor and private functions
//     this.toggleFormTrigger = toggleFormTrigger;
//     this.newAddressElement = newAddressElement;
//     this.newBillingAddressForm = newBillingAddressForm

// };

// SettingsController.prototype.init = function() {

//     var that = this;

//     //toggle form on click trigger
//     jQuery(that.toggleFormTrigger).click(function(){
//         that.toggleForm();
//     });

//     //on submit do ajax request
//     jQuery(that.newBillingAddressForm).submit(function(ev){
//         ev.preventDefault();
//         that.addNewAddress(that.newBillingAddressForm);
//     });

// jQuery('body').on('click', '.btn-delete-billing', function(ev){
//     ev.preventDefault();

//     var data = {
//         billing_id: jQuery(ev.currentTarget).attr('data-value')
//     };

//     that.deleteBillingAddress(data);

// })

// };

// SettingsController.prototype.bindUIelements = function(){

//     var
//         $window = $(window),
//         $stickyEl = $('.sidebar-navigation > ul'),
//         elTop = $stickyEl.offset().top;

//    $window.scroll(function() {
//         $stickyEl.toggleClass('sticky123', $window.scrollTop() > elTop);
//     });

// }

// SettingsController.prototype.toggleForm = function() {
//     jQuery(this.newAddressElement).slideToggle( "slow", function() {
//         // Animation complete.
//     });
// };

// SettingsController.prototype.addNewAddress = function(form) {

// var _form = $(form);
// var that = this;
// var req = $.ajax({
//     type: _form.attr('method'),
//     url: _form.attr('action'),
//     data: _form.serialize(),
//     success: that.getBillingAddress
// });

// req.done(function(){
//     that.toggleForm();
// });

// };

// SettingsController.prototype.getBillingAddress = function() {

//     var that = this;
//     $.ajax({
//         type: 'get',
//         url: '/account/billing_address',
//         success: function(data){
//             jQuery('#billing-address-wrapper').html(data);
//         },
//     })

// };

// SettingsController.prototype.deleteBillingAddress = function(data) {

//     var that = this;
//     $.ajax({
//         type: 'delete',
//         url: '/account/billing_address',
//         data: JSON.stringify(data),
//         contentType: "application/json",
//         success: that.getBillingAddress
//     });

// };

module.exports = SettingsController;



// WEBPACK FOOTER //
// ./public/src/js/pages/settingsPage.js